import { SubstrateSearchScenario } from 'owa-search-service';
import { action } from 'satcheljs';

const onFeedbackSubmitted = action(
    'onFeedbackSubmitted',
    (
        scenario: SubstrateSearchScenario,
        yesSelected: boolean,
        suggestionSetTraceId: string,
        feedbackString: string
    ) => ({
        scenario,
        yesSelected,
        suggestionSetTraceId,
        feedbackString,
    })
);

export default onFeedbackSubmitted;
